import { JobTypesContext } from 'context/JobTypesContext';
import { useContext } from 'react';

const useJobTypesContext = () => {
  return { ...useContext(JobTypesContext) };
};

export default useJobTypesContext;
